function stripBom(value) {
  if (!value) return "";
  return value.charCodeAt(0) === 0xfeff ? value.slice(1) : value;
}

function parseDelimited(text, delimiter) {
  const rows = [];
  let row = [];
  let cell = "";
  let inQuotes = false;

  for (let i = 0; i < text.length; i += 1) {
    const ch = text[i];
    const next = text[i + 1];

    if (ch === '"') {
      if (inQuotes && next === '"') {
        cell += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (!inQuotes && ch === delimiter) {
      row.push(cell);
      cell = "";
      continue;
    }

    if (!inQuotes && (ch === "\n" || ch === "\r")) {
      if (ch === "\r" && next === "\n") i += 1;
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
      continue;
    }

    cell += ch;
  }

  if (cell.length > 0 || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }

  return rows;
}

function chooseDelimiter(fileName, text) {
  const lower = (fileName || "").toLowerCase();
  if (lower.endsWith(".tsv")) return "\t";
  if (lower.endsWith(".csv")) return ",";
  const firstLine = (text.split(/\r?\n/)[0] || "");
  const tabs = (firstLine.match(/\t/g) || []).length;
  const commas = (firstLine.match(/,/g) || []).length;
  return tabs > commas ? "\t" : ",";
}

function normalizeHeader(header) {
  return String(header || "")
    .trim()
    .toLowerCase();
}

function splitList(value) {
  if (!value) return [];
  return String(value)
    .split(/[;,]/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function parseBool(value) {
  if (value === undefined || value === null || value === "") return false;
  const normalized = String(value).trim().toLowerCase();
  return ["1", "true", "yes", "y"].includes(normalized);
}

export function parseDeckImport(fileName, rawText) {
  const text = stripBom(rawText || "");
  const delimiter = chooseDelimiter(fileName, text);
  const rows = parseDelimited(text, delimiter).filter((row) => row.some((cell) => String(cell || "").trim() !== ""));

  if (!rows.length) {
    return { rows: [], preview: [], errors: ["File is empty."], delimiter };
  }

  const headers = rows[0].map(normalizeHeader);
  const idx = {
    front: headers.indexOf("front"),
    back: headers.indexOf("back"),
    tags: headers.indexOf("tags"),
    strict: headers.indexOf("strict"),
    accepted: headers.indexOf("accepted"),
  };

  const errors = [];
  if (idx.front < 0) errors.push("Missing required column: front");
  if (idx.back < 0) errors.push("Missing required column: back");
  if (errors.length) return { rows: [], preview: [], errors, delimiter };

  const parsedRows = [];
  for (let i = 1; i < rows.length; i += 1) {
    const row = rows[i];
    const front = String(row[idx.front] || "").trim();
    const back = String(row[idx.back] || "").trim();
    if (!front || !back) continue;

    parsedRows.push({
      front,
      back,
      tags: idx.tags >= 0 ? splitList(row[idx.tags]) : [],
      strict: idx.strict >= 0 ? parseBool(row[idx.strict]) : false,
      accepted: idx.accepted >= 0 ? splitList(row[idx.accepted]) : [],
    });
  }

  return {
    rows: parsedRows,
    preview: parsedRows.slice(0, 20),
    errors,
    delimiter,
  };
}

export function normalizeAnswer(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}
